module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trainer-manager"
  }, [_c('container', [_c('page-title', [_vm._v("Edit trainer: " + _vm._s(_vm.trainer.firstName) + " " + _vm._s(_vm.trainer.lastName))]), _vm._v(" "), _c('div', {
    staticClass: "trainer-manager__row"
  }, [_c('div', {
    staticClass: "trainer-manager__content"
  }, [(_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.error) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('v-form', {
    attrs: {
      "handle-submit": _vm.handleSubmit
    }
  }, [(_vm.trainer.photoUrl) ? _c('div', {
    staticClass: "current-photo"
  }, [_c('p', [_vm._v("Current Photo:")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.trainer.photoUrl,
      "alt": _vm.trainer.firstName,
      "width": "80px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "firstName",
      "data-vv-value-path": "input",
      "data-vv-name": "firstName",
      "data-vv-as": "first name",
      "message-error": _vm.errors && _vm.errors.first ? _vm.errors.first('firstName') : '',
      "has-error": _vm.errors && _vm.errors.has ? _vm.errors.has('firstName') : '',
      "block": true
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.trainer.firstName),
      callback: function($$v) {
        _vm.$set(_vm.trainer, "firstName", $$v)
      },
      expression: "trainer.firstName"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n              First name: *\n            ")])], 2), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "lastName",
      "data-vv-value-path": "input",
      "data-vv-name": "lastName",
      "message-error": _vm.errors && _vm.errors.first ? _vm.errors.first('lastName') : '',
      "has-error": _vm.errors && _vm.errors.has ? _vm.errors.has('lastName') : '',
      "block": true
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.trainer.lastName),
      callback: function($$v) {
        _vm.$set(_vm.trainer, "lastName", $$v)
      },
      expression: "trainer.lastName"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n              Last name: *\n            ")])], 2), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "name": "user.email",
      "data-vv-value-path": "input",
      "data-vv-name": "user.email",
      "message-error": _vm.errors && _vm.errors.first ? _vm.errors.first('user.email') : '',
      "has-error": _vm.errors && _vm.errors.has ? _vm.errors.has('user.email') : '',
      "block": true
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.trainer.user.email),
      callback: function($$v) {
        _vm.$set(_vm.trainer.user, "email", $$v)
      },
      expression: "trainer.user.email"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n              E-mail: *\n            ")])], 2), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "nickname",
      "data-vv-value-path": "input",
      "data-vv-name": "nickname",
      "message-error": _vm.errors && _vm.errors.first ? _vm.errors.first('nickname') : '',
      "has-error": _vm.errors && _vm.errors.has ? _vm.errors.has('nickname') : '',
      "block": true
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.trainer.nickname),
      callback: function($$v) {
        _vm.$set(_vm.trainer, "nickname", $$v)
      },
      expression: "trainer.nickname"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n              Nickname (username): *\n            ")])], 2), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "aboutMe",
      "block": true,
      "multiple-lines": true
    },
    model: {
      value: (_vm.trainer.aboutMe),
      callback: function($$v) {
        _vm.$set(_vm.trainer, "aboutMe", $$v)
      },
      expression: "trainer.aboutMe"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n              About me:\n            ")])], 2), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "introductionUrl",
      "data-vv-value-path": "input",
      "data-vv-name": "introductionUrl",
      "block": true
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.trainer.introductionUrl),
      callback: function($$v) {
        _vm.$set(_vm.trainer, "introductionUrl", $$v)
      },
      expression: "trainer.introductionUrl"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n              Trainer Introduction Web : \n            ")])], 2), _vm._v(" "), _c('v-upload-field', {
    attrs: {
      "url": "trainers/upload-image",
      "block": true
    },
    on: {
      "fileUrl": _vm.setPhotoUrl
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n              Photo upload:\n            ")])], 2), _vm._v(" "), _c('v-button', {
    attrs: {
      "block": true,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("\n            " + _vm._s(_vm.loading ? 'Loading...' : 'Save') + "\n          ")])], 1)], 1), _vm._v(" "), _c('update-password', {
    attrs: {
      "user-id": _vm.currentTrainer && _vm.currentTrainer.user ? _vm.currentTrainer.user.id : null
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ff4ca28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/TrainerManager/Edit.vue
// module id = 1679
// module chunks = 2